import Relay from 'react-relay';

export default class AssignAgentMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{assignAgent}`;
  }

  getVariables() {
    return {
      conversationId: this.props.conversationId,
      agentId: this.props.agentId
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on AssignAgentPayload {
        agent {
          name
          pid
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        agent: this.props.agentRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/AssignAgentMutation.js
 **/